import React, { useState } from "react";
import { connect } from "react-redux";
import PrimaryButtonPageLevel from "../../components/button/primary-button/PrimaryButtonLevelPage";
import PopupCloseButton from "../../components/button/special-button/PopupCloseButton";
import ConstantStrings from "../../constants/ConstantStrings";
import "./SelectService.style.css";
import { UpgradeAccountContext } from "./UpgradeAccount";
import SubPackage from "./SubPackage";
import ServiceItem from "./ServiceItem";
import { getConstantStringByLanguage } from "../../templates/helper/getConstantStringByLanguage";
import SelectGradeUpgrade from "./SelectGradeUpgrade";
import { isUserAlreadyHasPremiumInPackage } from "../../templates/helper/CheckAndGetAnonymousUserId";

const SELECT_SERVICE_STEP_1 = 0; // chọn cấp học
const SELECT_SERVICE_STEP_2 = 1; // chọn thời hạn => sang screen chọn phương thức thanh toán

let gradeLevels = [
  {
    name: getConstantStringByLanguage(ConstantStrings.PRIMARY_SCHOOL_LEVEL),
    sale: "-21%",
    level: getConstantStringByLanguage(ConstantStrings.PRIMARY_SCHOOL),
    key: "prek",
    gradeIds: [],
    active:true
  },
  {
    name: getConstantStringByLanguage(ConstantStrings.ELEMENTARY_SCHOOL_LEVEL),
    sale: "-33%",
    level: getConstantStringByLanguage(ConstantStrings.ELEMENTARY_SCHOOL),
    key: "elementary",
    gradeIds: [],
    active:true
  },
  {
    name: getConstantStringByLanguage(ConstantStrings.JUNIOR_HIGH_SCHOOL_LEVEL),
    sale: "-33%",
    level: getConstantStringByLanguage(ConstantStrings.JUNIOR_HIGH_SCHOOL),
    key: "juniorhigh",
    gradeIds: [],
    active:true
  },
  {
    name: getConstantStringByLanguage(ConstantStrings.SENIOR_HIGH_SCHOOL_LEVEL),
    sale: "-33%",
    level: getConstantStringByLanguage(ConstantStrings.SENIOR_HIGH_SCHOOL),
    key: "highschool",
    gradeIds: [],
    active:false
  },
];

const SelectService = ({
  handleNextStep,
  handleSelectStep,
  setNameSelectedService,
  userInfo,
}) => {
  const {
    services,
    setSubscriptionPackageId,
    SubscriptionPackageId,
    setDirectTransferConfirm,
    directTransferConfirm,
    setGradeIdsByServices,
  } = React.useContext(UpgradeAccountContext);
  const [selected, setSelected] = useState(SubscriptionPackageId);
  const [showPopupInfo, setShowPopupInfo] = useState(false);
  const [selectServiceStep, setSelectServiceStep] = useState(
    SELECT_SERVICE_STEP_1
  );
  const [selectGradeLevel, setSelectGradeLevel] = useState("");
  const [serviceItemsByGrade, setServiceItemsByGrade] = useState([]);


  const handleSelect = (_id, index, name) => {
    if (selected === _id) {
      setSelected(-1);
      setNameSelectedService("");
      setSubscriptionPackageId("");
      setDirectTransferConfirm({
        ...directTransferConfirm,
        transferAmount: "",
      });
      setGradeIdsByServices([]);
    } else {
      setSelected(_id);
      setNameSelectedService(name);
      handleSelectStep(1);
      setSubscriptionPackageId(_id);
      setDirectTransferConfirm({
        ...directTransferConfirm,
        transferAmount: services.filter((item) => item._id === _id)[0].price,
      });
      setGradeIdsByServices(
        serviceItemsByGrade.length > 0 ? serviceItemsByGrade[index].gradeIds : []
      );
    }

    handleNextStep();
    // }
  };

  const handleSelectServiceStep = (step, gradeLevel) => {
    setSelectServiceStep(step);
    setSelectGradeLevel(gradeLevel);
  };

  const handleSelectLevel = (level, key) => {
    setSelectGradeLevel(level);
    setSelectServiceStep(SELECT_SERVICE_STEP_2);
    setServiceItemsByGrade(
      services
        .filter((item) => item?.productId && item.productId.includes(key))
        .filter((item) => item?.duration !== 30)
        .sort((a, b) => b.price - a.price)
    );
  };

  const removePopup = () => {
    setShowPopupInfo(false);
  };

  const handleShowPopupInfo = () => {
    if (!showPopupInfo) {
      setShowPopupInfo(true);
    }
  };

  const getGradeIdsByServices = (key, services) => {
    const found = services.filter(i=> i?.productId).find((item) => item.productId.includes(key));
    return found ? found.gradeIds : [];
  };
  
  return (
    <div
      className="is-flex is-flex-gap-7 is-justify-content-center is-align-items-center"
      style={{
        width: "57.5rem",
        borderRadius: "1rem",
        background: "linear-gradient(90deg, #572CD1 0%, #48A9F8 100%)",
        padding: "1.5rem 3rem",
      }}
    >
      {/* {popupPremiumTo.status ? <>
        <div
          className="modal is-active modal-background"
          style={{ opacity: 1, zIndex: 1000 }}
        >
          <div className="modal-quiz is-relative">
            <h2 style={{ color: "#0A2A66" }} className="title-popup-quiz">
              Bạn vẫn còn hạn sử dụng . Bạn có muốn tiếp tục không ?
            </h2>
            <p className="documnent-quiz">
              Hạn sử dụng đến: <b> {userInfo?.premiumTo === null ? 'DD/mm/YYYY' : convertTimestamp(userInfo?.premiumTo)} </b>
            </p>

            <div className="is-flex " style={{ gap: "1rem", margin: "0 auto" }}>
              <PrimaryButtonPageLevel
                onClick={() => handleSelectPopupPremiumTo(popupPremiumTo._id, popupPremiumTo.index, popupPremiumTo.name)}
                style={{ height: "4rem", borderRadius: "1rem" }}
              >
                Tiếp tục
              </PrimaryButtonPageLevel>
            </div>

            <div
              onClick={removePopup}
              className=""
              style={{
                position: "absolute",
                top: "-8%",
                left: "-4%",
                zIndex: 9999,
                background: "transparent",
                border: "none",
                width: "5rem",
                fontSize: "2rem",
              }}
            >
              <PopupCloseButton />
            </div>
          </div>
        </div>
      </> : ""} */}

      {showPopupInfo && (
        <div
          className="modal is-active is-justify-content-end"
          style={{ zIndex: 1000 }}
        >
          <div className=" modal-background" style={{ opacity: "0.8" }}></div>
          <div
            className="has-background-kurio-main-color-white is-relative is-flex is-flex-direction-column is-align-items-center"
            style={{
              borderRadius: "2rem",
              height: "auto",
              maxHeight: "84.7%",
              width: "50rem",
              padding: "4rem",
            }}
          >
            <div
              className="is-flex is-flex-direction-column is-align-items-center select-service pr-2"
              style={{ overflowY: "auto", gap: "2.5rem" }}
            >
              <div className="is-flex is-flex-direction-column is-align-items-center is-justify-content-center is-flex-gap-6">
                <p
                  className="has-text-kurio-main-color-black has-text-weight-bold"
                  style={{
                    fontSize: "2rem",
                    lineHeight: "normal",
                    fontStyle: "normal",
                  }}
                >
                  {getConstantStringByLanguage(
                    ConstantStrings.KURIO_MAX_BENEFITS
                  )}
                  <span className="has-text-kurio-main-color-purple">
                    KURIO MAX
                  </span>
                </p>
                <img src="/images/upgrades/interest.png" alt="" />
              </div>
              <div className="is-flex is-flex-direction-column is-align-items-center is-justify-content-center is-flex-gap-6">
                <p
                  className="has-text-kurio-main-color-black has-text-weight-bold"
                  style={{
                    fontSize: "2rem",
                    lineHeight: "normal",
                    fontStyle: "normal",
                  }}
                >
                  {getConstantStringByLanguage(ConstantStrings.COMPARE_ABILITY)}
                </p>
                <img src="/images/upgrades/compare-feature.png" alt="" />
              </div>
              <PrimaryButtonPageLevel onClick={removePopup}>
                {getConstantStringByLanguage(ConstantStrings.CLOSE)}
              </PrimaryButtonPageLevel>
            </div>

            <div
              onClick={removePopup}
              className=""
              style={{
                position: "absolute",
                top: "-8%",
                left: "-4%",
                zIndex: 9999,
                background: "transparent",
                border: "none",
                width: "5rem",
                fontSize: "2rem",
              }}
            >
              <PopupCloseButton />
            </div>
          </div>
        </div>
      )}
      <SubPackage isMax={true} handleShowInfo={handleShowPopupInfo} />
      <div
        className="is-flex is-flex-direction-column is-align-items-flex-start"
        style={{ gap: "0.625rem", width: "100%" }}
      >
        <div
          className="is-flex is-align-items-center is-flex-gap-1"
          style={{ width: "100%" }}
        >
          <div className="is-flex is-align-items-center">
            <div
              className="has-background-kurio-main-color-white is-clickable has-text-centered has-text-kurio-main-color-purple is-flex is-align-items-center is-justify-content-center"
              style={{
                width: "2rem",
                height: "2rem",
                borderRadius: "1rem",
                aspectRatio: "1/1",
                opacity: 1,
              }}
              onClick={() => handleSelectServiceStep(SELECT_SERVICE_STEP_1, "")}
            >
              <p
                className="is-uppercase"
                style={{
                  fontFamily: "Paytone One",
                  fontSize: "1rem",
                  fontWeight: 400,
                  lineHeight: "normal",
                }}
              >
                1
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="49"
              height="4"
              viewBox="0 0 49 4"
              fill="none"
            >
              <path
                opacity={
                  selectServiceStep === SELECT_SERVICE_STEP_2 ? "1" : "0.3"
                }
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.20011 4H0.666779V0H1.20011C2.30468 0 3.20011 0.89543 3.20011 2C3.20011 3.10457 2.30468 4 1.20011 4ZM7.73345 2C7.73345 0.89543 8.62888 0 9.73345 0H10.8001C11.9047 0 12.8001 0.89543 12.8001 2C12.8001 3.10457 11.9047 4 10.8001 4H9.73345C8.62888 4 7.73345 3.10457 7.73345 2ZM17.3334 2C17.3334 0.89543 18.2289 0 19.3334 0H20.4001C21.5047 0 22.4001 0.89543 22.4001 2C22.4001 3.10457 21.5047 4 20.4001 4H19.3334C18.2289 4 17.3334 3.10457 17.3334 2ZM26.9334 2C26.9334 0.89543 27.8289 0 28.9334 0H30.0001C31.1047 0 32.0001 0.89543 32.0001 2C32.0001 3.10457 31.1047 4 30.0001 4H28.9334C27.8289 4 26.9334 3.10457 26.9334 2ZM36.5335 2C36.5335 0.89543 37.4289 0 38.5335 0H39.6001C40.7047 0 41.6001 0.89543 41.6001 2C41.6001 3.10457 40.7047 4 39.6001 4H38.5335C37.4289 4 36.5335 3.10457 36.5335 2ZM46.1334 2C46.1334 0.89543 47.0289 0 48.1334 0H48.6668V4H48.1334C47.0289 4 46.1334 3.10457 46.1334 2Z"
                fill="#FAFBFC"
              />
            </svg>
            <div
              className="has-background-kurio-main-color-white is-clickable has-text-centered has-text-kurio-main-color-purple is-flex is-align-items-center is-justify-content-center"
              style={{
                width: "2rem",
                height: "2rem",
                borderRadius: "1rem",
                aspectRatio: "1/1",
                opacity: selectServiceStep === SELECT_SERVICE_STEP_2 ? 1 : 0.3,
              }}
            >
              <p
                className="is-uppercase"
                style={{
                  fontFamily: "Paytone One",
                  fontSize: "1rem",
                  fontWeight: 400,
                  lineHeight: "normal",
                }}
              >
                2
              </p>
            </div>
          </div>
          <p
            className="has-text-kurio-main-color-white has-text-weight-bold has-text-centered"
            style={{ fontSize: "1rem", lineHeight: "normal", width: "100%" }}
          >
            {getConstantStringByLanguage(
              selectServiceStep === SELECT_SERVICE_STEP_1
                ? ConstantStrings.SELECT_SCHOOL_LEVEL
                : ConstantStrings.SELECT_EXPIRATION_DATE
            )}
          </p>
        </div>
        <div
          className="is-flex is-flex-direction-column is-align-items-center is-flex-gap-4 is-justify-content-center is-align-self-stretch"
          style={{
            borderRadius: "0.5rem",
            background: "#CAD1F8",
            border: "0.5rem solid #FAFBFC",
            boxShadow: "0rem 0.25rem 0rem 0rem #0A2A66",
            padding: "1.5rem 0rem",
            width: "100%",
          }}
        >
          {selectServiceStep === SELECT_SERVICE_STEP_1 && (
              <div className="is-flex is-flex-direction-column is-flex-gap-4">
                {gradeLevels.filter(i=> i.active).map((item, index) => (
                  <SelectGradeUpgrade
                    key={index}
                    item={item}
                    isAlreadyPremium={isUserAlreadyHasPremiumInPackage(
                      userInfo?.premiumInfo,
                      getGradeIdsByServices(item.key, services)
                    )}
                    handleSelectLevel={handleSelectLevel}
                  />
                ))}
              </div>
            )}
          {selectServiceStep === SELECT_SERVICE_STEP_2 && (
            <>
              {serviceItemsByGrade.map((item, index) => (
                <ServiceItem
                  key={index}
                  index={index}
                  item={item}
                  handleSelect={handleSelect}
                  type={
                    item.duration === ConstantStrings.DURATION_PACKAGE_12_MONTH
                      ? 2
                      : 3
                  }
                  gradeLevel={selectGradeLevel}
                  isMax={true}
                  isPrek={item?.productId?.includes("prek")}
                />
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    userInfo: state.grades.listUserInfo,
  };
}

export default connect(mapStateToProps)(SelectService);
